/**
 * @Description 指南针类，指南针初始化以及更新
 * @Author iCEA
 * @Date 2020-10-29
 * @Version 1.0
 */

import { Camera } from './Camera'

class Compass {
  /**
   * 指南针类构造函数
   * @param {number} offset 指南针图片初始偏移量，默认90
   * @returns {Camera} 指南针监听的摄像机
   */
  constructor (offset, cam) {
    /**
       * @type {number} offset 指南针图片初始偏移量，默认90
       */
    this.offset = offset
    /**
       * @type {boolean} 指南针显示与隐藏
       */
    this.showCompass = true

    /**
       * @type {Camera} 指南针监听的摄像机
       */
    this.cam = cam
  }

  /**
   * 根据相机模式更改指南针div块的displa属性（none/block）
   */
  setCompass () {
    if (!this.showCompass) {
      document.getElementById('compassoutdoor').style.display = 'none'
      document.getElementById('indoorscale').style.display = 'none'
      document.getElementById('indoor').style.display = 'none'
      return
    }
    if (this.cam.cameraMode) {
      // 全景视角
      document.getElementById('compassoutdoor').style.display = 'none'
      document.getElementById('indoorscale').style.display = 'block'
      document.getElementById('indoor').style.display = 'block'
    } else {
      document.getElementById('compassoutdoor').style.display = 'block'
      document.getElementById('indoorscale').style.display = 'none'
      document.getElementById('indoor').style.display = 'none'
    }
  }

  /**
   * 指南针更新函数，获取相机经度调整div的旋转
   */
  update () {
    if (!this.showCompass) return
    let angle = this.cam.lon + this.offset

    if (this.cam.cameraMode && !this.cam.v2gsign && !this.cam.g2vsign) {
      // 全景视角
      document.getElementById('indoor').style.transform = 'rotateZ(' + angle + 'deg)'
    } else if (!this.cam.v2gsign && !this.cam.g2vsign && !!document.getElementById('compassoutdoor')) {
      // 模型视角
      angle = -(angle + 180)
      document.getElementById('compassoutdoor').style.transform = 'rotateZ(' + angle + 'deg)'
    }
  }
}

export {
  Compass
}
